import { useId, type ReactNode } from 'react';

export function ConsoleDetails({ title, children }: { title: string; children: ReactNode }) {
  return <details className="console-details"><summary>{title}</summary><div>{children}</div></details>;
}

export function ConsoleTabs<T extends string>({ label, value, items, onChange, panelPrefix }: {
  label: string; value: T; items: ReadonlyArray<readonly [T, string]>; onChange(value: T): void; panelPrefix?: string;
}) {
  const id = useId();
  return <div className="console-tabs" role="tablist" aria-label={label}>
    {items.map(([key, text], index) => <button key={key} id={`${id}-${key}`} type="button" role="tab"
      aria-selected={value === key} aria-controls={panelPrefix?`${panelPrefix}-${key}`:undefined} tabIndex={value === key ? 0 : -1} onClick={() => onChange(key)}
      onKeyDown={event => {
        const next = event.key === 'ArrowRight' ? (index + 1) % items.length : event.key === 'ArrowLeft' ? (index + items.length - 1) % items.length : event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : -1;
        const destination = items[next];
        if (!destination) return;
        event.preventDefault(); onChange(destination[0]);
        event.currentTarget.parentElement?.querySelectorAll<HTMLButtonElement>('[role=tab]')[next]?.focus();
      }}>{text}</button>)}
  </div>;
}
